//@flow
import React, { useState, useEffect, Component } from 'react';
import Slider from 'react-slick';
import { CallToAction } from 'components/atoms/callToAction';
import { ShareButton } from 'components/atoms/shareButton';
import RecommendedCard from 'components/molecules/recommendedCard';
import { PaginationControl } from 'components/molecules/paginationControl';
import type { RecommendedScreenType } from 'types/common';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
import { ExploreButton } from 'components/atoms/exploreButton';
import { OverlayPortal } from 'components/templates/overlayPortal';
import { OverlayModal } from 'components/templates/overlayModal';
import { RouteNames } from 'router';
import { useViewport } from 'components/templates/viewportProvider';
import { ProjectActions } from 'modules/project/actions';
import { bindActionCreators } from 'redux';
import { ProjectSelector } from 'modules/project/selector';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
//eslint-disable-next-line
import styles from "./styles.scss";

type Props = {
  recommendedList: Array<RecommendedScreenType>,
  fetchTitle: Component,
  displayHeader?: boolean,
  displayOptions?: boolean,
  optionsComponent?: Component,
  isRestaurant?: boolean,
  isDefinedRoute: boolean,
  onClick: void,
  displayProjectOverlay?: boolean,
  showFilter?: boolean,
};

const RecommendedCarousel = (props: Props) => {
  const { height, isMobile } = useViewport();
  const [viewport, setViewport] = useState({
    width: 0,
    height: 0,
  });

  const updateWindowDimensions = () => {
    setViewport({
      ...viewport,
      width: window.innerWidth,
      height: window.innerHeight,
    });
  };

  const [activeSlide, setActiveSlide] = useState(0);
  const [slider, setSlider] = useState();
  const [showProjects, setShowProjects] = useState(false);

  useEffect(() => {
    updateWindowDimensions();
    window.addEventListener('resize', updateWindowDimensions);
    return () => {
      window.removeEventListener('resize', updateWindowDimensions);
    };
  }, []);

  const {
    recommendedList,
    fetchTitle,
    isRestaurant = false,
    isDefinedRoute,
    onClick,
    displayProjectOverlay = false,
    showFilter,
    type,
    activeFilters,
    isFiltered,
    filteredProjects,
    breadcrumbList,
  } = props;
  const projectData = props.projectList;

  if (!recommendedList || !fetchTitle) {
    return null;
  }

  // Render Footer
  const next = () => {
    slider.slickNext();
  };

  const previous = () => {
    slider.slickPrev();
  };

  const renderFooter = () => {
    // TODO Check random value for KEY.
    return (
      <div className="section-footer">
        <PaginationControl
          className={'section-footer-item'}
          theme={'dark-theme'}
          mode={'slider'}
          currentIndex={activeSlide + 1}
          total={recommendedList.length}
          onNextClick={next}
          onPreviousClick={previous}
          key={'10'}
        />
      </div>
    );
  };

  // Render Content
  const renderIntro = () => {
    return <div className={'recommended-heading'}>{fetchTitle}</div>;
  };

  const renderProjectOverlayButton = () => {
    return (
      <div className={'projects-overlay-button'}>
        <ExploreButton
          onClick={() => setShowProjects(true)}
          text={'EXPLORE ALL PROJECTS'}
        />
      </div>
    );
  };

  const settings = {
    className: 'slider variable-width',
    infinite: false,
    //  centerMode: !(activeSlide === 0 || activeSlide === recommendedList.length),
    slidesToShow: 1,
    slidesToScroll: 1,
    variableWidth: true,
    speed: 1000,
    beforeChange: (current, next) => setActiveSlide(next),
    arrows: false,
    draggable: true,
    cssEase: 'cubic-bezier(0.77, 0, 0.175, 1)',
  };

  const showOverlay = showProjects ? (
    <OverlayPortal>
      <OverlayModal
        data={isFiltered ? filteredProjects : projectData}
        theme={isMobile ? 'light-theme' : 'dark-theme'}
        type={'projects'}
        toggleRoute={'workcations'}
        onClosePress={() => setShowProjects(false)}
        activeFilters={activeFilters}
        showFilter={showFilter}
        breadcrumbList={[
          {
            breadcrumbName: breadcrumbList[1].breadcrumbName,
            breadcrumbLink: breadcrumbList[1].breadcrumbLink,
          },
          {
            breadcrumbName: breadcrumbList[2].breadcrumbName,
            breadcrumbLink: breadcrumbList[2].breadcrumbLink,
          },
        ]}
      />
    </OverlayPortal>
  ) : null;

  const renderContent = () => {
    return (
      <div>
        <Row className={'list-header'}>
          <Col md={2} sm={9}>
            {renderIntro()}
          </Col>
          <Col md={3} sm={3}>
            {displayProjectOverlay ? renderProjectOverlayButton() : null}
          </Col>
        </Row>
        <Slider ref={c => setSlider(c)} {...settings} style={{ height: '70%' }}>
          {recommendedList.map(list => {
            return (
              <RecommendedCard
                data={list}
                type={type}
                onClick={onClick}
                className={'recommended-card'}
                key={list.id}
                isRestaurant={isRestaurant}
                isDefinedRoute={isDefinedRoute}
              />
            );
          })}
        </Slider>
      </div>
    );
  };

  return (
    <div
      className={'recommended-container section-container'}
      style={{ height }}
    >
      {renderContent()}
      {renderFooter()}
      {showOverlay}
    </div>
  );
};

const mapStateToProps = state => {
  return {
    filteredProjects: ProjectSelector.getFilteredProjects(state),
    activeFilters: ProjectSelector.getActiveProjectFilterNames(state),
    isFiltered: ProjectSelector.isProjectsFiltered(state),
  };
};

const mapDispatchToProps = dispatch => {
  const { toggleProjectFilter, clearProjectFilters } = ProjectActions;
  return bindActionCreators(
    {
      toggleProjectFilter,
      clearProjectFilters,
    },
    dispatch
  );
};

const connectedComponent = connect(
  mapStateToProps,
  mapDispatchToProps
)(RecommendedCarousel);

export default withRouter(connectedComponent);
